import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { LANGUAGE_KEY } from '../constants';
import { AsyncStorage } from 'react-native';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';

function get_language(langCode){
	const dash_index = langCode.indexOf('-')
	if (dash_index >= 0){
		if(langCode.startsWith('zh')){
			return (langCode.substring(dash_index+1, langCode.length)).toLowerCase()
		}
		return langCode.substring(0, dash_index)
	}
	return langCode
}

export default () => muster()
	.path('languages.saveLanguage', {
	  call: async ({ req }, { get, set, call }) => {
      const { languageObj } = req.args[0];
			const [regionCode] = await getValues(get(['config.regionCode']));
			await set('languages.loadingLanguage', true);
			// EBANK-9918 : Multlilanguage: Language setting Change for CH
			if(regionCode === 'CH'){
				await call('userprofile.saveUserPrefLanguage', { prefLanguage : languageObj });
			}
			else{
        const [oReturn] = await getValues(
          get(
            `roster.data.userprofile.setUserPreferredLanguage["${languageObj.langCode}"]["${guidStr}"]`
          )
        );

        isValidJsonString(oReturn).then(async (result) => {
          const [messages] = await getValues(get('i18n.messages'));
          if (result.returnCode === 0) {
            await AsyncStorage.setItem('SelectedLanguageCode', languageObj.langCode);
            await AsyncStorage.setItem('SelectedLanguage', languageObj.language);
            await call('ui.history.push', { pathname: '/loadingview' }, true);
            let langCode = get_language(languageObj.langCode);
            await set('auth.langCode', langCode);
            alert(messages['app.profile.language.changeLanguageMsg']);
            setTimeout(() => {
              set('languages.destLanguage', languageObj.language);
              set('languages.destLanguageCode', languageObj.langCode);
              call('ui.history.push', { pathname: '/profile' }, true);
            }, 1500);
          } else {
            alert(messages['app.login.unableToConnect']);
            call('ui.history.push', { pathname: '/profile' }, true);
          }
        }).catch(async (error) => {
          alert(messages['app.docsign.invalidjson.response']);
        });
			}
		}
	})
	.path('languages.getlanguages', {
		call: async ({ req }, { get, set, call }) => {
      let localLang = await AsyncStorage.getItem('SelectedLanguage');
      let localLangCode = await AsyncStorage.getItem('SelectedLanguageCode');

      // todo: should pick from language-list.json default
      if (!localLang) localLang = 'English'
      if (!localLangCode) localLangCode = 'en-GB'

      set('languages.destLanguage', localLang);
      set('languages.destLanguageCode', localLangCode);

      await AsyncStorage.setItem('SelectedLanguageCode', localLangCode);
      await AsyncStorage.setItem('SelectedLanguage', localLang);
    }
  })
  .path('languages.saveLanguageAtLogin', {
    call: async ({ req }, { get, set, call }) => {
      const { languageObj } = req.args[0];
      await AsyncStorage.setItem('SelectedLanguageCode', languageObj.langCode);
      await AsyncStorage.setItem('SelectedLanguage', languageObj.language);
      const langCode = get_language(languageObj.langCode);
      await set('auth.langCode', langCode);
      await set('languages.isLanguageChange', true);
      await call('auth.resetInfoMessage');
      setTimeout(async () => {
        await call('ui.history.push', { pathname: '/' }, true);
        await call('ui.history.push', { pathname: '/login' }, true);
        await set('languages.destLanguage', languageObj.language);
        await set('languages.destLanguageCode', languageObj.langCode);
        await call('banner.getDowntime')
        const [messages] = await getValues(get('i18n.messages'));
        alert(messages['app.profile.language.changeLanguageMsg']);
      }, 0);
    }
  })
  .path('languages.displayAppBottom', {
    call: async ({ req }, { get, set, call }) => {
      set('languages.profileAppBottom', req.args[0].displayEntitlment);
    }
  })

  .path('language.setLanguageValue', {
    call: async ({ req }, { get, set, call }) => {
      let language = req.args[0] && req.args[0].language, languageData = req.args[0] && req.args[0].languageData;
      if (language != 4) {
        if (language && language.toLowerCase() != 'en') {
          await AsyncStorage.setItem('SelectedLanguageCode', language);
          let regionLangList = languageData.languageList, langObjs = [];
          const selectedLanguage = await AsyncStorage.getItem('SelectedRegion');
          regionLangList.map((item) => {
            if (item.country === selectedLanguage) {
              langObjs = item.languages;
            }
          });
          langObjs.map((item) => {
            if (item.langCode === language) {
              AsyncStorage.setItem('SelectedLanguage', item.language);
            }
          });
        } else {
          await AsyncStorage.setItem('SelectedLanguageCode', 'en-GB');
          await AsyncStorage.setItem('SelectedLanguage', 'English');
        }
      } else {
        await AsyncStorage.setItem('SelectedLanguageCode', 'en-GB');
        await AsyncStorage.setItem('SelectedLanguage', 'English');
      }
    }
  })

  .path('languages.regionLangSave', variable(false))
  .path('languages.destLanguage', variable())
  .path('languages.destLanguageCode', variable())
  .path('languages.destRegion', variable())
  .path('languages.profileAppBottom', variable(false))
  .path('languages.selNewRegn', variable())
  .path('languages.successMsg', variable(false))
  .path('auth.langCode', variable())
  .path('languages.loadingLanguage', variable(false))
  .path('languages.isLanguageChange', variable(false));
